module.exports = __webpack_public_path__ + "static/media/P Cohen N13 (7).13fc5988.JPG";